import { forwardRef } from "react";
function SvgRawWritePromptIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="none"
        fillRule="evenodd"
        stroke="#545454"
        strokeWidth={2}
        d="m18.414 3.414.172.172a2 2 0 0 1 0 2.828L8 17H5.03L5 14 15.586 3.414a2 2 0 0 1 2.828 0zM4 21h16M14.002 5 17 8"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawWritePromptIcon);
export default ForwardRef;
